import { useMemo } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

type Result = {
	trackClick: () => void;
};

export function usePetitionPageUserLinkTracking(): Result {
	const {
		data: {
			petition: {
				user: { id },
			},
		},
	} = usePetitionDetailsPageData();

	const track = useTracking();

	return useMemo(
		() => ({
			trackClick: () => {
				void track('petition_page_user_link_click', {
					clicked_user_id: id,
					source_location: 'petition_page',
				});
			},
		}),
		[track, id],
	);
}
